import React from 'react';

const EngineType = ({ rowData }) => {
  const { engine_type } = rowData;
  return <div>{engine_type}</div>;
};

export default EngineType;
